interface FaqItem {
  question: string;
  answer: string;
}

const FAQ_ITEMS: FaqItem[] = [
  {
    question: '土豪漫画网上的漫画真的全部免费吗？',
    answer: '是的！土豪漫画网承诺全站漫画永久免费在线阅读。我们通过广告合作维持运营，读者无需支付任何费用即可畅享海量韩漫、日漫、国漫资源，从热门连载到经典完结作品一应俱全。',
  },
  {
    question: '漫画更新频率怎么样？会不会断更？',
    answer: '我们的编辑团队每天实时追踪各大漫画连载平台，确保第一时间同步更新最新话。日漫通常在每周三至周五密集更新，韩漫多为每周更新，国漫则根据连载节奏稳定更新。极少出现断更情况。',
  },
  {
    question: '支持手机阅读吗？阅读体验如何？',
    answer: '完全支持！土豪漫画网采用响应式设计，在手机、平板、电脑上都有流畅的阅读体验。我们专为移动端优化了下拉式阅读模式，无需翻页，手指下滑即可连续阅读，加载速度极快。',
  },
  {
    question: '如何快速找到我想看的漫画？',
    answer: '你可以通过首页的"主题索引"按类型浏览，也可以通过"热门排行"发现当前最火的漫画，还能在"热门话题"中看到大家都在讨论的作品。如果想精确搜索，可以使用站内搜索功能按作品名查找。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-[72px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">常见问题</h2>
          <p className="text-foreground-500 text-sm mt-3">关于土豪漫画网，你可能想了解的一切</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {FAQ_ITEMS.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-base font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="inline-flex w-6 h-6 rounded-full bg-primary-100 text-primary-600 text-xs font-bold items-center justify-center shrink-0 mt-0.5">
                  Q
                </span>
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}